import { InjectionToken } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

// Exported for testing
export const detectBrowser = (winRef: WindowRef, browsersType: Array<string>): boolean => {

    browsersType = browsersType.map(browserType => browserType.toLocaleLowerCase());

    let browsersName = [];
    const ua = winRef.nativeWindow.navigator.userAgent.toLowerCase();
    const iosIpad = ua.indexOf('ipad') > -1;
    const iosIPhone = ua.indexOf('iphone') > -1;
    const webKit =  ua.indexOf('webkit') > -1;
    const safariAgent = ua.indexOf('safari') > -1;
    const chromeAgent = ua.indexOf('chrome') > -1;

    switch (true) {
        // Detect iPad and WebKit
        case iosIpad && webKit:
            browsersName = ['ipad', 'webkit'];
            break;
        // Detect iPhone and WebKit
        case iosIPhone && webKit:
            browsersName = ['iphone', 'webkit'];
            break;
        // Detect Safari
        case safariAgent:
            // user-agent of the Chrome browser also includes the Safari browser’s user-agent, it means that the browser is Chrome
            (safariAgent && chromeAgent) ? browsersName = ['chrome'] : browsersName = ['safari'];
            break;
        default:
            browsersName = ['other'];
    }

    return !browsersName.some((browserName) => browsersType.indexOf(browserName.toLocaleLowerCase()) === -1);
};

// Used to type the imported function
export type DetectBrowser = (winRef: WindowRef, browsersType: Array<string>) => boolean;
// Used when @Inject the function into a class
/* istanbul ignore next */
export const DETECT_BROWSER = new InjectionToken('DETECT_BROWSER', {
    factory: () => detectBrowser
});
